namespace Core {

    export interface IInfoPopupScope {
        popupMessage: string;
        popupHeader: string;
    }

    const template = `
        <lightbox 
            show="showPopup"
            close="close()"
            header-text="popupHeader"
            lightbox-class="lightbox-confirmation-popup"
            >
            <div class="message-container">
                <span ng-bind-html="popupMessage"></span>
            </div>
        </lightbox>
    `;

    export class InfoPopupService {
        private defaultPopupScope: IInfoPopupScope;


        constructor(
            private basePopupService: Core.BasePopupService
        ) {
            this.defaultPopupScope = {
                popupMessage: '',
                popupHeader: ''
            };
        }

        public showPopup(customScope: IInfoPopupScope): ng.IPromise<any> {
            const defScope = this.defaultPopupScope;
            const popupParams = {
                popupContainer: 'body',
                popupScope: {
                    ...defScope,
                    ...customScope
                }
            };
            return this.basePopupService.showPopup(template, popupParams);
        }
    }

    angular.module('TR').service('infoPopupService', InfoPopupService);
}
